import React, { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import attachFileIcon from "../../../../../../../styles/svg/attach-file.svg";
import addfile from "../../../../../../../styles/svg/add-file.svg";
import { createCardAttachment } from "../../../../../../../sevices/apiCards";
import AttachFileDialog from "./AttachFileDialog";
import { CustomButton } from "../../../../../../../components/Button/Button";
import useMutate from "../../../../../../../hooks/useMutate";
import "./AttachFile.scss";
import { useParams, useSearchParams } from "react-router-dom";

const AttachFile = ({ cardId, isIconBtn = false, isMobile = false }) => {
  const [loading, setLoading] = React.useState(false);
  const [openAttachFile, setOpenAttachFile] = React.useState(false);
  const queryClient = useQueryClient();
  const { id: boardId } = useParams();
  const [searchParams] = useSearchParams();

  const { mutate: createCardAttachmentMutate } = useMutate(createCardAttachment, [],
    () => { },
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cardAttachment`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`feeds`, String(boardId),searchParams.get("milestone")],
      });
      setLoading(false);
      setOpenAttachFile(false);
    },
    () => {
      setLoading(false);
    },
  );

  const handleOpenAttachFile = useCallback(() => {
    setOpenAttachFile(true);
  }, []);

  return (
    <>
      {openAttachFile && (
        <AttachFileDialog
          open={openAttachFile}
          close={setOpenAttachFile}
          cardId={cardId}
          createCardAttachmentMutate={createCardAttachmentMutate}
          loading={loading}
          setLoading={setLoading}
        />
      )}

      {isIconBtn ? (
        <div>
          <CustomButton
            component="label"
            className={"new-add-file reset-btn"}
            onClick={handleOpenAttachFile}
          >
            <img src={addfile} alt="" />
          </CustomButton>
        </div>
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          className={`${isMobile
              ? "mobile-attach-btn "
              : "white-button d-flex justify-content-center align-items-center header-attach-btn attach-btn-icon"
            }`}
          component="label"
          onClick={handleOpenAttachFile}
        >
          <img
            src={attachFileIcon}
            className={`header-filter-icon ${!isMobile && "mr-2"}`}
            alt="not found"
          />
          {isMobile ? (
            ""
          ) : (
            <span className="attach-btn-content"> Add Attachment</span>
          )}
        </CustomButton>
      )}
    </>
  );
};

export default React.memo(AttachFile);
